import * as FullStory from '@fullstory/browser';
import { FIREBASE_PROJECT_ID, FULLSTORY_ORG_ID } from '@paperstac/env';
import React from 'react';
var fullStorySupported = ['paperstac-dev', 'paperstac-prod'].includes(FIREBASE_PROJECT_ID);
FullStory.init({ orgId: FULLSTORY_ORG_ID, devMode: !fullStorySupported });
function useFullStory() {
    return React.useMemo(function () { return FullStory; }, []);
}
export default useFullStory;
